/*
  Retour arriere : on revient a l'endroit quitte, pas en haut de la page.

  Fichier separe de global.js a dessein : une erreur survenant plus haut dans
  global.js interromprait tout ce qui suit, y compris ce code.

  Historique des tentatives, pour ne pas refaire les memes paris :

    1. Reconnaitre le retour par le type de navigation. performance ne rapporte
       pas toujours back_forward, et le script sortait aussitot.
    2. Memoriser par URL. Les parametres que Shopify ajoute (_ab, _fd, _sc sur
       une boutique protegee) changent l'adresse entre l'aller et le retour :
       la position devenait introuvable.
    3. Memoriser par identifiant d'entree d'historique seul. Une application
       tierce appelant replaceState efface notre marqueur au passage.

  Cette version ne parie plus sur un seul mecanisme : la position est ecrite
  sous DEUX cles, l'identifiant d'entree d'historique et le chemin de la page,
  et la restauration se declenche si l'un OU l'autre des deux indices de retour
  est present. Il faut que les deux mecanismes echouent ensemble pour perdre la
  position.

  Diagnostic : ajouter ?scrolldebug=1 a l'URL affiche ce que le script decide.
*/
(() => {
  const STORE = 'dilection:scroll';
  const DEBUG = location.search.includes('scrolldebug=1');
  const notes = [];

  const say = (message) => {
    notes.push(message);
    if (DEBUG) console.log('[scroll]', message);
  };

  const read = () => {
    try {
      return JSON.parse(sessionStorage.getItem(STORE)) || {};
    } catch (error) {
      return {};
    }
  };

  // Le chemin seul : insensible aux parametres ajoutes par Shopify.
  const pathKey = 'p:' + location.pathname;

  const state = history.state || {};
  const returning = typeof state.dilectionScrollKey === 'string';
  let histKey = state.dilectionScrollKey;

  if (!returning) {
    histKey = 'h:' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    try {
      history.replaceState({ ...state, dilectionScrollKey: histKey }, '');
    } catch (error) {
      histKey = null;
      say('replaceState refuse');
    }
  }

  const entry = performance.getEntriesByType('navigation')[0];
  const legacy = performance.navigation && performance.navigation.type === 2;
  const wasBack = entry ? entry.type === 'back_forward' : legacy;

  say('entree ' + (returning ? 'connue' : 'nouvelle') + ', navigation ' + (wasBack ? 'arriere' : 'directe'));

  // ---------- Memorisation ----------

  let pending = false;
  const remember = () => {
    try {
      const positions = read();
      const y = window.scrollY;
      positions[pathKey] = y;
      if (histKey) positions[histKey] = y;
      sessionStorage.setItem(STORE, JSON.stringify(positions));
    } catch (error) {
      /* Navigation privee ou quota atteint : on renonce sans bruit. */
    }
  };

  window.addEventListener(
    'scroll',
    () => {
      if (pending) return;
      pending = true;
      setTimeout(() => {
        remember();
        pending = false;
      }, 250);
    },
    { passive: true }
  );

  window.addEventListener('pagehide', remember);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') remember();
  });

  // ---------- Restauration ----------

  const panel = () => {
    if (!DEBUG) return;
    const box = document.createElement('div');
    box.style.cssText =
      'position:fixed;left:0;right:0;bottom:0;z-index:99999;background:#000;color:#0f0;' +
      'font:12px/1.5 monospace;padding:10px;white-space:pre-wrap';
    box.textContent = notes.join('\n');
    document.body.appendChild(box);
  };

  // Un seul des deux indices suffit : ils echouent rarement ensemble.
  if (!returning && !wasBack) {
    window.addEventListener('load', panel);
    return;
  }

  const positions = read();
  const target = (histKey && positions[histKey]) || positions[pathKey];

  if (typeof target !== 'number' || target <= 0) {
    say('aucune position memorisee (ni pour l entree, ni pour ' + pathKey + ')');
    window.addEventListener('load', panel);
    return;
  }

  say('position a retablir : ' + target);

  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  /*
    Les images arrivent apres coup et la page grandit encore : tant qu'elle est
    trop courte pour atteindre la position voulue, on la repousse a chaque
    image. On s'arrete des que le visiteur defile lui-meme.
  */
  let active = true;
  ['wheel', 'touchmove', 'keydown'].forEach((event) =>
    window.addEventListener(
      event,
      () => {
        active = false;
      },
      { once: true, passive: true }
    )
  );

  const started = performance.now();
  const settle = () => {
    if (!active) {
      say('interrompu par le visiteur a ' + Math.round(window.scrollY));
      panel();
      return;
    }

    const reachable = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    window.scrollTo(0, Math.min(target, reachable));

    if (reachable >= target && Math.abs(window.scrollY - target) <= 1) {
      say('atteinte en ' + Math.round(performance.now() - started) + 'ms');
      panel();
      return;
    }

    if (performance.now() - started > 3000) {
      say('abandon : page haute de ' + reachable + ' pour une cible de ' + target);
      panel();
      return;
    }

    requestAnimationFrame(settle);
  };

  settle();
})();
